import React from 'react';
import classNames from 'classnames';
import {
  string,
  oneOf,
  arrayOf
} from 'prop-types';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { buildImageURL } from '../../../utils/product-add-on-utils';
import { ICONS } from '../../../utils/product-add-on-constants';

const AttachLaborTooltip = React.forwardRef(({
  label,
  contentHeading,
  contentDescriptionList,
  contentSubHeading,
  contentList,
  channel,
  size,
}, buttonRef) => {

  const toolTipLabelClasses = classNames({
    'u__default-link': true,
    'product-add-on-tooltip-content__label': true,
    'product-add-on-tooltip-content__attach-labor-tool-tip': channel === 'desktop',
    scrollTouch: size === 'large',
  });

  const tooltipBody = (
    <div className="product-add-on-tooltip-content" data-channel={`${channel}`}>
      <div className="product-add-on-tooltip-content__header"> {contentHeading} </div>
      <div className="product-add-on-tooltip-content__body">
        {
          contentDescriptionList
            .map((listItem, index) => <p className="product-add-on-tooltip-content__body__" key={index}>{listItem}</p>)
        }
      </div>

      <div className="product-add-on-tooltip-content__sub-heading">{contentSubHeading}</div>
      <ul className="product-add-on-tooltip-content__list">
        {contentList.map((listItem, index) => <li key={index}> {listItem} </li>)}
      </ul>
    </div>
  );

  return (
    <Tooltip
      channel={channel}
      placement="bottom"
      content={tooltipBody}
      className="product-add-on-tooltip-content__wrapper"
      closeButton
    >
      <button ref={buttonRef} type="button" className={toolTipLabelClasses}>
        {label}
        <img
          src={buildImageURL(ICONS.info)}
          alt="information tooltip"
          className="product-add-on-tooltip-content__label__suffix"
        />
      </button>
    </Tooltip>
  );
});

AttachLaborTooltip.displayName = 'ProductAddOns-tooltips-attach-labor-tooltip';

AttachLaborTooltip.propTypes = {
  /** What view to render ['desktop' || 'mobile']  */
  channel: oneOf(['desktop', 'mobile']),
  /** Render large or small version */
  size: oneOf(['large', 'small']),
  /** toolTipLabel -> Renders as anchor link for the tooltip */
  label: string,
  /** toolTipContentHeading -> Renders as Heading for tooltip content */
  contentHeading: string.isRequired,
  /** toolTipContentBody -> Renders tooltip body text */
  contentDescriptionList: arrayOf(string).isRequired,
  /** toolTipContentBody -> Renders tooltip body text */
  contentSubHeading: string.isRequired,
  /** toolTipContentBody -> Renders tooltip body text */
  contentList: arrayOf(string).isRequired,
};

AttachLaborTooltip.defaultProps = {
  label: 'What to Expect',
  channel: 'desktop',
  size: 'large',
};

export { AttachLaborTooltip };
